import { Component, OnInit } from '@angular/core';
import { NovedadService } from 'src/app/services/novedad.service';
import { Novedad } from 'src/app/models/novedad.model';
import { Categoria } from 'src/app/models/categoria.model';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-new-list',
  templateUrl: './new-list.component.html',
  styleUrls: ['./new-list.component.scss'],
})
export class NewListComponent implements OnInit {
  userFilter: any = { titulo: '' };
  novedades: Novedad[];
  categoria: any;
  id: number;
  idCategory: number;
  loading: boolean;
  noresults: boolean;

  categories = [
    { id: 1, name: 'Novedades' },
    { id: 2, name: 'Información General' },
    { id: 3, name: 'Notificaciones' },
    { id: 5, name: 'Capacitaciones' },
  ];

  constructor(private novedadService: NovedadService) {}

  ngOnInit() {
    this.getNovedades();
    this.onActivate(event);
  }

  getNovedades() {
    this.loading = true;
    this.novedadService.getNovedades().subscribe(
      (data) => {
        this.novedades = data.data;
        this.loading = false;
      },
      (err) => console.error(err),
      () => console.log('ok')
    );
  }


  getNovedadesByIdCategory(id) {
    this.novedadService.getNovedadesByCategory(id).subscribe((data) => {
      this.novedades = data.data;
      if (this.novedades.length === 0) {
        this.noresults = true;
      } else {
        this.noresults = false;
      }

    });
  }

  onActivate(event) {
    window.scroll(0, 0);
  }
}
